import { BellIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../contexts/AuthContext';

export function Header() {
  const { user } = useAuth();

  return (
    <header className="hidden lg:flex items-center justify-between h-16 bg-white border-b border-secondary-200 px-8">
      <div>
        <h1 className="text-xl font-semibold text-secondary-900">
          Welcome back, {user?.firstName}!
        </h1>
        <p className="text-sm text-secondary-500">
          Here's what's happening with your business today.
        </p>
      </div>
      
      <div className="flex items-center space-x-4">
        <button className="relative p-2 text-secondary-400 hover:text-secondary-500">
          <BellIcon className="h-6 w-6" />
          <span className="absolute top-1.5 right-1.5 h-2 w-2 rounded-full bg-red-500"></span>
        </button>
      </div>
    </header>
  );
}
